export const apiUrl = 'https://projects-api.poyser.me/api'
export const apiResourcesUrl = 'https://projects-api.poyser.me/uploaded'

const path = function (path) {
    return `${apiUrl}${path}`
}

const requests = {
    auth: {
        login: {
            url: path('/auth/login'),
            method: 'post'
        }
    },

    meta: {
        all: {
            url: path('/metas'),
            method: 'get'
        },
        delete (metaId) {
            return {
                url: path(`/metas/${metaId}`),
                method: 'delete',
                config: {
                    withAuth: true
                }
            }
        },
        edit (metaId) {
            return {
                url: path(`/metas/${metaId}`),
                method: 'post',
                config: {
                    withAuth: true,
                    opts: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                }
            }
        },
        create: {
            url: path('/meta/create'),
            method: 'post',
            config: {
                withAuth: true,
                opts: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            }
        }
    },

    project: {
        get: {
            url: path(''),
            method: 'get'
        },
        view (projectId) {
            return {
                url: path(`/${projectId}`),
                method: 'get'
            }
        },
        create: {
            url: path('/create'),
            method: 'post',
            config: {
                withAuth: true,
                opts: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            }
        },
        edit (projectId) {
            return {
                url: path(`/update/${projectId}`),
                method: 'post',
                config: {
                    withAuth: true,
                    opts: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                }
            }
        }
    }
}

export default requests
